<template>
  <div class="container">
    <!-- 面包屑导航 -->
    <div class="breadcrumb">
      <el-breadcrumb separator="">
        <el-breadcrumb-item
        >
          <div class="div1">系统管理</div>
        </el-breadcrumb-item
        >
        <el-breadcrumb-item
        >
          <div class="div2">域名证书监控</div>
        </el-breadcrumb-item
        >
      </el-breadcrumb>
    </div>
    <!-- 面包屑导航 teamManage -->
    <!-- 添加团队 -->
    <div class="content">
      <h2>域名证书监控</h2>
      <h3>数据筛选</h3>
      <div>
        <el-form :inline="true" id="search" size="small">
          <el-form-item label="域名">
            <el-input
                v-model="search.domain"
                placeholder="请输入域名"
                clearable
            ></el-input>
          </el-form-item>
          <el-form-item label="状态">
            <el-select v-model="search.status"
                       filterable
                       placeholder="请选择状态"
                       clearable
                       :default-first-option="true">
              <el-option v-for="items in dictionaries.domain_status"
                         :key="items.dictId"
                         :label="items.dictName"
                         :value="items.dictId"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="fetchData('search')"
            >查询
            </el-button
            >
            <el-button
                type="primary"
                plain
                @click="fetchData('reset')"
            >重置
            </el-button
            >
          </el-form-item
          >
        </el-form>
      </div>
    </div>
    <div class="content">
      <h3 class="data-list-title">
        数据列表
        <el-button size="small" type="primary" @click="showDialog('新增', 'add')"
        >新增
        </el-button>
        <el-button size="small" type="button" @click="refreshAll()"
        >刷新所有域名
        </el-button>
      </h3>

      <!-- <div>{{ parArray.indexOf("authorityAdd") == 1 }}{{ parArray }}</div> -->
      <lb-table
          :column="column"
          :data="domainList"
          pagination
          :total="page.totalNum"
          layout="total, sizes, prev, pager, next, jumper"
          :page-sizes="[5, 10, 20, 30, 50]"
          :current-page.sync="page.currentPage"
          :page-size="page.pageSize"
          @size-change="handleSizeChange"
          @p-current-change="handleCurrentChange"
      >
      </lb-table>
    </div>
    <!-- 管理客户等级 -->

    <!-- ============================= el-dialog ============================= -->
    <el-dialog
        :title="dialog.title"
        :visible.sync="dialog.visible"
        width="30%"
        :append-to-body="true"
        :before-close="handleClose"
        class="company-dialog"
    >
      <div class="dialog-content">
        <div>
          <el-form :model="form" :rules="rules" ref="form" label-width="100px">
            <el-form-item label="域名" prop="name">
              <el-input v-model="form.domain" size="mini" maxlength="200" show-word-limit></el-input>
            </el-form-item>
          </el-form>
        </div>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialog.visible = false">取 消</el-button>
        <el-button type="primary" @click="dialogConfirm">确 定</el-button>
      </div>
    </el-dialog>
    <!-- ============================= el-dialog end ============================= -->
  </div>
</template>

<script>
// import { FormItem } from 'element-ui';
import LbTable from '../../../components/lb-table/lb-table'
import {checkSort} from '@/utils/rules.js';

export default {
  name: 'role',
  components: {LbTable},
  data() {
    return {
      search: {},
      domainList: [], // 公司列表
      column: [
        {label: '域名', prop: 'domain'},
        {
          label: '状态',
          render: (h, scope) => {
            for (let i = 0; i < this.dictionaries.domain_status.length; i++) {
              if (this.dictionaries.domain_status[i].dictId == scope.row.status) {
                return (
                    <div>
                      {this.dictionaries.domain_status[i].dictName}
                    </div>
                )
              }
            }
            return (
                <div>
                  未知
                </div>
            )
          }
        },
        {label: '证书过期时间', prop: 'certDate'},
        {label: '服务器IP', prop: 'ip'},
        {label: '最后检查时间', prop: 'lastCheckedTime'},
        {label: '创建时间', prop: 'createdTime'},
        {label: '最后更新时间', prop: 'updatedTime'},
        {
          label: '操作',
          render: (h, scope) => {
            return (
                <div>
                  <el-link size="mini" type="primary" onClick={() => {
                    this.refreshSelected(scope.row, scope.$index)
                  }}>刷新
                  </el-link>
                  <el-link size="mini" type="danger" onClick={() => {
                    this.onDelete(scope.row, scope.$index)
                  }}>删除
                  </el-link>
                </div>
            )
          }
        }],
      page: {pageNo: 1, pageSize: 10, totalNum: 0, currentPage: 1},
      dialog: {visible: false, title: "编辑", type: ''},
      form: {
        domain: '' // 域名 string
      },
      rules: {
        name: [
          {required: true, message: '请输入公司名称', trigger: 'blur'},
          {min: 1, max: 20, message: '长度在 1 到 20 个字符', trigger: 'blur'}
        ]
      },
      dictionaries: { // 字典数据
        domain_status: [] // 状态
      },
      brandList: [], // 品牌管理列表数据
      parArray: [] // 按钮权限
    };
  },
  created() {
    this.fetchData()
    // 获取字典值
    for (let type in this.dictionaries) {
      this.getDictionaries(type)
    }
  },
  /*
  watch: {
    permissionFilterText (val) {
      this.$refs.tree.filter(val);
    }
  },
  */
  methods: {
    fetchData(type) {
      if (type == 'reset') {
        this.search = {}
        this.page.pageNo = 1
        this.page.pageSize = 10
        this.page.currentPage = 1
      }
      let params = {
        pageNo: this.page.pageNo,
        pageSize: this.page.pageSize
      }
      if (type == 'search') {
        this.page.currentPage = 1
        this.page.pageNo = 1
        params.pageNo = 1
        params = Object.assign(params, this.search);
        // 去除字符串 前后 空格
        for (let item in params) {
          if (typeof params[item] === "string") {
            params[item] = params[item].trim()
          }
        }
      }
      this.axios
          .post('/basic/domain/getPageList', params)
          .then((res) => {
            this.domainList = res.data.list
            this.page.totalNum = res.data.totalNum
          }).catch((err) => {
        console.log(err)
      })
    },
    handleCurrentChange(currentChange) {
      this.page.pageNo = currentChange
      this.fetchData()
    },
    handleSizeChange(sizeChange) {
      this.page.pageSize = sizeChange
      this.fetchData()
    },
    // 获取字典数据
    getDictionaries(type) {
      if (type && this.dictionaries[type].length > 0) {
        return
      }
      const params = {groupId: type}
      this.$api.dictionaries(params).then((res) => {
        this.dictionaries[type] = res.data
      }).catch((err) => {
        console.log(err)
      })
    },
    // 显示  dialog
    showDialog(title, type, row) {
      this.dialog.type = type
      this.currentRow = row
      this.dialog.visible = true;
      this.dialog.title = '新增';
      this.form = {
        domain: '' // 域名 string
      }
      this.$refs["form"].resetFields();
    },
    handleClose(done) {
      this.$confirm('确认关闭？')
          .then(_ => {
            done();
          })
          .catch(_ => {
          });
    },
    // 确认后判断各类操作
    dialogConfirm() {
      const type = this.dialog.type
      switch (type) {
        case 'add':
          this.submitForm('form')
          break;
        case 'edit':
          this.editCompany()
          break;
        default:
          console.log(type)
      }
    },
    // 表单验证
    submitForm(formName) {
      this.addDomain();
    },
    // 添加域名
    addDomain() {
      const params = this.form
      this.axios
          .post('/basic/domain/create', params)
          .then((res) => {
            if (res.code == 0) {
              this.dialog.visible = false;
              this.fetchData()
              this.$message({type: 'success', message: '操作成功!'});
            } else {
              this.$message.error(res.message)
            }
          }).catch((err) => {
        console.log(err)
      })
    },
    // 删除
    onDelete(item, index) {
      this.$confirm('此操作将删除选中的域名, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.axios
            .get('/basic/domain/remove?id=' + item.id)
            .then((res) => {
              if (res.code == 0) {
                this.fetchData()
                this.$message({
                  type: 'success',
                  message: '删除成功!'
                });
              } else {
                this.$message.error(res.message)
              }
            }).catch((err) => {
          console.log(err)
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        });
      });
    },
    // 刷新所有
    refreshAll() {
      this.$confirm('是否发送钉钉消息?', '提示', {
        confirmButtonText: '是',
        cancelButtonText: '否',
        type: 'warning'
      }).then(() => {
        this.axios
            .get('/basic/domain/refreshAll?sendMessage=true')
            .then((res) => {
              if (res.code == 0) {
                this.fetchData()
                this.$message({
                  type: 'success',
                  message: '刷新成功!'
                });
              } else {
                this.$message.error(res.message)
              }
            }).catch((err) => {
          console.log(err)
        })
      }).catch(() => {
        this.axios
            .get('/basic/domain/refreshAll')
            .then((res) => {
              if (res.code == 0) {
                this.fetchData()
                this.$message({
                  type: 'success',
                  message: '刷新成功!'
                });
              } else {
                this.$message.error(res.message)
              }
            }).catch((err) => {
          console.log(err)
        })
      });
    },
    // 刷新单个
    refreshSelected(item, index) {
      this.axios
          .get('/basic/domain/refreshSelected?ids=' + item.id)
          .then((res) => {
            if (res.code == 0) {
              this.fetchData()
              this.$message({
                type: 'success',
                message: '刷新成功!'
              });
            } else {
              this.$message.error(res.message)
            }
          }).catch((err) => {
        console.log(err)
      });
    }
  }
}
</script>

<style scoped lang="scss">
.div1 {
  margin-left: -16px;
  background: url(../../../assets/breadcrumb2.png);
  width: 120px;
  height: 30px;
  text-align: center;
  line-height: 30px;
  color: #2d7edf;
}

.div2 {
  margin-left: -16px;
  background: url(../../../assets/breadcrumb1.png);
  width: 120px;
  height: 30px;
  text-align: center;
  line-height: 30px;
  color: #fff;
}

.div3 {
  margin-left: -8px;
  background: url(../../../assets/breadcrumb3.png);
  width: 120px;
  height: 30px;
  text-align: center;
  line-height: 30px;
  color: #2d7edf;
}

//
//#search{
//  display: flex;
//  .el-form-item{
//    flex: 1;
//    .el-form-item__content{
//      width: 80%;
//    }
//  }
//}

.content {
  .el-button {
    margin-bottom: 10px;
  }

  .el-badge {
    margin-left: 10px;
  }
}

.roleList {
  border: 1px solid #f0f3fd;
  border-radius: 5px;

  .title {
    color: #333333;
    line-height: 40px;
    padding: 0 10px;
    background-color: #f0f3fd;

    .el-badge {
      margin-top: 10px;
      margin-left: 10px;
    }
  }

  .list {
    padding: 20px;

    .el-tag {
      border: 0;
      margin-right: 10px;
      margin-bottom: 10px;
    }
  }
}

.dialog-content {
  // min-height: 210px;
  .el-tree {
    max-height: 300px;
    overflow: auto;
  }

  .el-radio {
    // display: block;
    // margin: 8px 0;
  }
}
</style>
<style lang="scss">
.content {
  .el-link {
    margin: 0 5px;
  }

  h4 {
    padding-top: 10px;
    border-top: 1px solid #bbbbbb;
  }
}
</style>
